import React, { useEffect, useState } from "react"
import styled from "styled-components"
import BannerImg from '../../images/banner-bg.jpg'
import useDataUserAccount from "../../dataHooks/useDataUserAccount"
import useMe from "../../hooks/useMe"
import Tabs from "../../sharedComponents/Tabs"
import { FullScreenLoadingCover, LoadingIcon, useProfileCache } from "@prosolve/common-components-ui"
import AccountImage from "./AccountImage"
import NameForm from "./NameForm"
import PasswordForm from "./PasswordForm"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  min-height: 100%;
  background: ${({theme}) => theme.backgrounds.pure};
`

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
`

const ColumnGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const RowGroup = styled.div`
  display: flex;
  gap: 10px;
`

export default () => {
  const [selectedTab, setSelectedTab] = useState('Account Settings')
  const me = useMe()
  const [isInitialized, setIsInitialized] = useState(false)

  const { isLoading, userAccount, fetchUserAccount } = useDataUserAccount()
  const { setProfileFromUserAccount } = useProfileCache()

  const { userId, source } = me

  const {
    firstName,
    lastName
  } = userAccount || {}

  const handleUpdate = async () => {
    const account = await fetchUserAccount(userId)
    setProfileFromUserAccount(account)
  }

  useEffect(() => {
    if (source === 'prosolve') {
      fetchUserAccount(userId)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source, userId])

  useEffect(() => {
    if (isLoading === false && !isInitialized) {
      setIsInitialized(true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  return (
    <Container>
      <ColumnGroup style={{ padding: '20px' }}>
        {
          !isInitialized
          ?
          <div style={{ textAlign: 'center' }}>
            <LoadingIcon />
          </div>
          :
          source !== 'prosolve'
          ?
          <div style={{ textAlign: 'center' }}>
            This page is unavailable for your account
          </div>
          :
          <>
            <img alt='Banner' src={BannerImg} height='160px' />
            <RowGroup style={{ gap: '30px', paddingLeft: '50px' }}>
              <div style={{ position: 'relative', top: '-50px', height: '75px' }}>
                <AccountImage me={me} userAccount={userAccount} onUpdate={handleUpdate} />
              </div>
              <div style={{ fontSize: '32px' }}>
                {`${firstName || ''} ${lastName || ''}`}
              </div>
            </RowGroup>

            <div style={{ paddingTop: '25px' }}>
              <Tabs
                tabs={['Account Settings']}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
              />
            </div>

            <ColumnGroup style={{ gap: '30px' }}>
              {selectedTab === 'Account Settings' && (
                <>
                  <div style={{ paddingTop: '10px' }}>
                    <Title>My Account</Title>
                    <div style={{ paddingTop: '10px' }}>View and edit your personal information below</div>
                  </div>
                  <NameForm userAccount={userAccount} onUpdate={handleUpdate} />
                  <PasswordForm userAccount={userAccount} />
                </>
              )}
            </ColumnGroup>
          </>
        }

        {isInitialized && isLoading &&
          <FullScreenLoadingCover />
        }
      </ColumnGroup>
    </Container>
  )
}
